import { CssFontSource, CustomFontSource, Stripe } from '@stripe/stripe-js'

let Stripe: Stripe
export let stripeCurrency = 'usd'
export let stripeInstallationId = ''
export function ensureStripeInitialized(): Stripe {
  if (!Stripe) {
    const {
      stripePublishableKey,
      stripeAccountId,
      stripeInstallationId: instalationId,
      stripeCurrency: currency,
    } = document.querySelector<HTMLDivElement>('#payment-gateway-keys').dataset
    Stripe = globalThis.Stripe?.(stripePublishableKey, {
      stripeAccount: stripeAccountId,
      betas: ['disable_deferred_intent_client_validation_beta_1'],
    })
    stripeInstallationId = instalationId
    stripeCurrency = currency
  }
  return Stripe
}

export function ensureStripeScriptLoaded(): Promise<void> {
  if (globalThis.Stripe) return Promise.resolve()

  const lazyScript = document.querySelector('script[data-lazy-src*="stripe"]')
  if (!lazyScript) return Promise.resolve()

  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = lazyScript.getAttribute('data-lazy-src')
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Failed to load Stripe.js'))
    lazyScript.parentNode.insertBefore(script, lazyScript)
    lazyScript.remove()
  })
}

export function buildStripeFonts(): Array<CssFontSource | CustomFontSource> {
  const fonts: Array<CssFontSource | CustomFontSource> = []
  const googleFontsSrc = (document.getElementById('cf-lander-font-families') as HTMLLinkElement)?.href
  if (googleFontsSrc) {
    fonts.push({ cssSrc: googleFontsSrc })
  }

  try {
    const serializedCustomFonts = JSON.parse(
      (document.getElementById('cf-lander-serialized-custom-fonts') as HTMLScriptElement)?.textContent ?? '[]'
    )
    fonts.push(
      ...serializedCustomFonts.map(
        (customFont) =>
          ({
            family: customFont.family,
            src: customFont.files.map((src) => `url(${new URL(src, document.location.href).toString()})`).join(','),
          } as CustomFontSource)
      )
    )
  } catch (e) {
    console.error('Error preparing custom fonts to stripe elements', e)
  }

  return fonts
}
